var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40015363_4531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83247 11.6667C5.83242 11.7751 5.86258 11.8813 5.91956 11.9736C5.97654 12.0658 6.05809 12.1403 6.15506 12.1887L7.32172 12.7721C7.41068 12.8165 7.50952 12.8375 7.60886 12.833C7.70821 12.8285 7.80475 12.7987 7.88932 12.7464C7.9739 12.6941 8.04369 12.621 8.09208 12.5341C8.14047 12.4472 8.16585 12.3494 8.16581 12.25V8.16667C8.16594 7.87756 8.27341 7.59879 8.46739 7.38442L12.6808 2.72417C12.7563 2.64049 12.806 2.53673 12.8238 2.42543C12.8416 2.31413 12.8267 2.20006 12.7811 2.09701C12.7354 1.99396 12.6609 1.90635 12.5665 1.84476C12.4721 1.78318 12.3619 1.75027 12.2491 1.75H1.74914C1.63633 1.75004 1.52595 1.78279 1.43137 1.84429C1.33679 1.90578 1.26207 1.99338 1.21627 2.09648C1.17046 2.19957 1.15553 2.31374 1.17329 2.42514C1.19104 2.53655 1.24072 2.64042 1.31631 2.72417L5.53089 7.38442C5.72487 7.59879 5.83234 7.87756 5.83247 8.16667V11.6667Z",
    stroke: "#99A1AF",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40015363_4531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.ce3ca3afa1fedcb97edf98dc9c155e1e.svg";
export { ForwardRef as ReactComponent };